/*
 *   File : App.js
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations : js-cookie,react-toastify
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

//Custom component
import { Login, ForgotPassword } from './Container/Auth';
import { CustomHeader, LeftNavigationWidget, Footer } from './Component/Navigation';
import { Dashboard } from './Container/Home';
import { CorridorDetail, FieldDetails } from './Container/Corridor-Master';
import { FieldMaster } from './Container/Field-Master';
import { FileOperations } from './Container/File-Operations';
import { getAccessToken } from './Helper/cookie';

function App() {

    const [toggleSidebar, setToggleSidebar] = useState(true);
    const [token, setToken] = useState(getAccessToken());
    const [browserZoom, setBrowserZoom] = useState(100);

    useEffect(() => {
        const interval = setInterval(() => {
            setToken(getAccessToken());
        }, 500); // checks every 500ms

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        // Removing modal backdrop for all modals when use gesture
        window.addEventListener('popstate', function () {
            if (document.querySelector(".modal-backdrop")) {
                document.querySelector(".modal-backdrop").remove();
                document.body.style.overflow = 'unset';
            };

        });
    }, [window.location.pathname]);

    useEffect(() => {
        // Update browser zoom level
        function updateZoom() {
            const newZoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
            const roundedZoom = Math.ceil(newZoom / 5) * 5;
            setBrowserZoom(roundedZoom);
        }
        updateZoom();
        window.addEventListener("resize", updateZoom);
        return () => {
            window.removeEventListener("resize", updateZoom);
        };
    }, []);

    useEffect(() => {
        // Calculate the default zoom level based on the device pixel ratio
        const default_zoom = window.devicePixelRatio;

        const initial_value = `${default_zoom * 100}%`;

        // if (initial_value === "150%") {
        //     document.body.style.zoom = "80%";
        // } else {
        //     document.body.style.zoom = "100%";
        // }
    }, []);

    // handle sidebar toggle
    const _handleToggleSidebar = () => {
        setToggleSidebar(!toggleSidebar);
    };

    return (
        <div className={` ${browserZoom >= 150 ? 'e-app-zoom-level-7' :
            browserZoom === 125 ? 'e-app-zoom-level-8' :
                browserZoom === 110 ? 'e-app-zoom-level-9' : null
            }`}>
            {token ?
                <Router>
                    <div className='container-fluid min-h-100vh'>
                        <div className='row'>
                            <div className={`${toggleSidebar ? `col-2` : `col-1`} px-0 transition d-xl-block d-lg-block d-md-none d-none`}>
                                <LeftNavigationWidget toggle={toggleSidebar} />
                            </div>
                            <div className={`${toggleSidebar ? `col-xl-10 col-lg-10 col-md-12` : `col-xl-11 col-lg-11 col-md-12`} px-0  transition`}>
                                <CustomHeader handleToggle={_handleToggleSidebar} />

                                <div className='min-h-100vh e-body-bg position-relative'>
                                    <Routes>
                                        <Route path="/" element={<Navigate to="/corridor-config" replace />} />
                                        <Route path="/corridor-config" element={<Dashboard />} />
                                        <Route path="/field-master" element={<FieldMaster />} />
                                        <Route path="/corridor-details" element={<CorridorDetail />} />
                                        <Route path="/corridor-details/add-fields" element={<FieldDetails />} />
                                        <Route path="/upload" element={<FileOperations />} />
                                        <Route path="*" element={<Navigate to="/corridor-config" replace />} />
                                    </Routes>
                                    <Footer />
                                </div>

                            </div>
                        </div>
                    </div>
                </Router>
                :
                <Router>
                    <div className='position-relative min-h-100vh'>
                        <Routes>
                            <Route exact path="/" element={<Login />} />
                            {/* <Route exact path="/login" element={<Login />} /> */}
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="*" element={<Login />} />
                        </Routes>
                        {/* footer */}
                        {/* <Footer /> */}
                    </div>
                </Router>
            }

            <ToastContainer
                autoClose={3000}
                pauseOnHover={false}
                position="bottom-right" />
        </div>
    );
}

export default App;
